import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ArrowUpRight } from "lucide-react";

export default function Blog() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/blog").then(({ data }) => setPosts(data)).catch(() => setPosts([]));
  }, []);

  return (
    <section id="blog" className="section" data-testid="blog-section">
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-14">
          <div>
            <div className="eyebrow mb-4">Blog</div>
            <h2 className="font-serif text-4xl md:text-5xl text-white tracking-tight max-w-3xl leading-[1.05]">
              Field notes on <span className="gold-text italic">applied AI</span>.
            </h2>
          </div>
          <p className="max-w-md text-white/55 text-sm leading-relaxed">
            Weekly insights on AI infrastructure, automation, and SaaS engineering.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
          {posts.map((p, i) => (
            <a
              key={p.slug}
              href="#contact"
              data-testid={`blog-card-${i}`}
              className="group block rounded-3xl overflow-hidden border border-white/8 hover:border-gold-500/30 transition-all"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img src={p.cover} alt={p.title} loading="lazy"
                     className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
              </div>
              <div className="p-6 bg-ink-200">
                <div className="flex items-center justify-between text-[10px] font-mono uppercase tracking-[0.2em] text-gold-300">
                  <span>{p.category}</span>
                  <span className="text-white/40">{p.read_time}</span>
                </div>
                <div className="mt-3 font-serif text-xl text-white leading-snug">{p.title}</div>
                <div className="mt-2 text-sm text-white/55 line-clamp-2">{p.excerpt}</div>
                <div className="mt-4 inline-flex items-center gap-1 text-sm text-gold-300">
                  Read <ArrowUpRight className="h-3.5 w-3.5" />
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
